import { IGetterFn } from '@/store/types';

// 缓存清理类型
export const cacheTypes: IGetterFn = () => {
  return [
    // { optionValue: '物品', optionKey: 'model', postUrl: '/model/type/item/cacheclear' },
    // { optionValue: '材料', optionKey: 'material', postUrl: '/material/type/item/cacheclear' },
    // { optionValue: '模型', optionKey: 'mesh', postUrl: '/baseinfo/ueitem/mesh/cacheclear' },
    // { optionValue: '角色', optionKey: 'actor', postUrl: '/baseinfo/ueitem/actor/cacheclear' },
    { optionValue: '物品', optionKey: 'model', postUrl: '/v1/system/cache/item/clear' },
    { optionValue: '材料', optionKey: 'material', postUrl: '/v1/system/cache/material/clear' },
    { optionValue: '模型', optionKey: 'mesh', postUrl: '/v1/system/cache/mesh/cacheclear' },
    { optionValue: '角色', optionKey: 'actor', postUrl: '/v1/system/cache/actor/cacheclear' },
    { optionValue: '型材产品', optionKey: 'sectionProduct', postUrl: '/v1/system/cache/sectionproduct/cacheclear' },
  ];
};

// 数据清理类型
export const clearDataTypes: IGetterFn = () => {
  return [
    { optionValue: '样板间', optionKey: 'blankroom', postUrl: '' },
  ];
};

// 索引刷新类型
export const refreshTypes: IGetterFn = () => {
  return [
    // { optionValue: '物品', optionKey: 'model', postUrl: '/model/type/item/index/refresh' },
    // { optionValue: '材料', optionKey: 'material', postUrl: '/material/type/item/index/refresh' },
    // { optionValue: '专案', optionKey: 'group', postUrl: '/design/group/index/refresh' },
    // { optionValue: '杂志', optionKey: 'magazine', postUrl: '/design/magazine/index/refresh' },
    { optionValue: '物品', optionKey: 'model', postUrl: '/v1/system/cache/item/refreshindex' },
    { optionValue: '材料', optionKey: 'material', postUrl: '/v1/system/cache/material/refreshindex' },
    { optionValue: '专案', optionKey: 'group', postUrl: '/v1/system/cache/dpg/refreshindex' },
    { optionValue: '杂志', optionKey: 'magazine', postUrl: '/v1/system/cache/mag/refreshindex' },
    { optionValue: '型材产品', optionKey: 'sectionProduct', postUrl: '/v1/asset/sectionproduct/refreshindex' },
  ];
};

// 缩略图更新类型
export const thumbTypes: IGetterFn = () => {
  return [
    { optionValue: '物品', optionKey: '1', postUrl: '' },
    { optionValue: '材料', optionKey: '2', postUrl: '' },
    { optionValue: '专案', optionKey: '3', postUrl: '' },
    { optionValue: '杂志', optionKey: '4', postUrl: '' },
  ];
};
